import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export const faro =
  process.env.REACT_APP_STAGE === 'production' || process.env.REACT_APP_STAGE === 'staging'
    ? initializeFaro({
        url: process.env.REACT_APP_FARO_URL || '',

        app: {
          name: `oya-schedule-${process.env.REACT_APP_STAGE || 'local'}`,
          version: process.env.REACT_APP_VERSION || '0.0.0',
          environment: process.env.REACT_APP_STAGE || 'local' // 'development' | 'production' | 'staging'
        },

        sessionTracking: {
          enabled: true,
          persistent: true, // mantém sessão entre reloads (localStorage)
          samplingRate: 1 // 1 = 100% das sessões
        },

        batching: {
          enabled: true,
          sendTimeout: 250, // ms entre batches
          itemLimit: 50 // itens por batch
        },

        instrumentations: [
          ...getWebInstrumentations({
            captureConsole: true
            // captureConsoleDisabledLevels: [] // captura todos os níveis
          }),

          new TracingInstrumentation({
            instrumentationOptions: {
              propagateTraceHeaderCorsUrls: [new RegExp(`${process.env.REACT_APP_OYA_CARE_API_URL}/*`)]
            }
          })
        ]
      })
    : undefined;
